import axios from "../../../axios";

export function getSpecialProductList() {
  const response = axios.get(`/products/special-list/`);
  return response;
}
